import {
  API_ERROR_MAP,
  STRIPE_CANCELLED_CODES,
  STRIPE_DECLINE_FALLBACK_MESSAGE,
  STRIPE_DECLINE_MESSAGE_GROUPS,
  STRIPE_ERROR_TYPE,
  STRIPE_UNEXPECTED_STATE_CODES,
} from 'types'
import getApiErrorKey from './getApiErrorKey'
import getMessageForErrorKey from './getMessageForErrorKey'

// Map Stripe decline code to message.
const getDeclineMessage = (payload) => {
  const code = payload.decline_code || payload.code
  if (!code) return STRIPE_DECLINE_FALLBACK_MESSAGE
  const declineGroup = STRIPE_DECLINE_MESSAGE_GROUPS.find((group) =>
    group.codes.includes(code),
  )
  return declineGroup?.message ?? STRIPE_DECLINE_FALLBACK_MESSAGE
}

// Response body may be at response.data or response.body. Return it only if it
// has decline fields.
const getStripePayload = (error) => {
  const body = error?.response?.data ?? error?.response ?? error?.body
  if (body == null) return error
  if (body.decline_code == null && body.code == null) return error
  return body
}

// Resolve Stripe/payment errors (API key, decline code, or raw body) to a
// user-facing message.
const getStripeErrorMessage = (error) => {
  if (!error) return API_ERROR_MAP.STRIPE_GENERIC_ERROR

  const apiErrorKey = getApiErrorKey(error)
  if (apiErrorKey) return getMessageForErrorKey(apiErrorKey)

  const payload = getStripePayload(error)
  const { code, type } = payload

  if (type === STRIPE_ERROR_TYPE.VALIDATION_ERROR) {
    return API_ERROR_MAP.STRIPE_VALIDATION_ERROR
  }

  // Intent-state and cancellation codes must be checked before the decline
  // mapping below: they carry a `code` but are not declines, so the decline
  // branch would otherwise swallow them into STRIPE_DECLINE_FALLBACK_MESSAGE
  // and tell the member to contact their bank.
  if (STRIPE_UNEXPECTED_STATE_CODES.includes(code)) {
    return API_ERROR_MAP.AUTHNET_ERROR_OCCURRED
  }
  if (
    STRIPE_CANCELLED_CODES.includes(code) ||
    type === STRIPE_ERROR_TYPE.CANCEL
  ) {
    return API_ERROR_MAP.STRIPE_PAYMENT_CANCELLED
  }

  const hasDeclineInfo =
    type === STRIPE_ERROR_TYPE.CARD_ERROR ||
    payload.decline_code != null ||
    payload.code != null
  if (hasDeclineInfo) return getDeclineMessage(payload)

  // Use the Stripe body's message if available, otherwise fall back to generic
  return (
    (payload !== error && payload.error) || API_ERROR_MAP.STRIPE_GENERIC_ERROR
  )
}

export default getStripeErrorMessage
